<template>
    <div>
        <div>
            <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'新增资源需求'}]"/>
            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">
                                        新增资源需求
                                    </div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>需求信息</h1>
                                    </div>
                                    <div class="h-pieceCon2" style="padding:0">
                                        <div class="h-formLine weekplandetail34">
                                            <el-form :model="zy" label-position="right" ref="zy" :inline="true"
                                                     :rules="rules"
                                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                                <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                                    <el-input value="经销商" :disabled="true" v-if="!isagent"></el-input>
                                                    <el-select v-model="zy.euType" :v="zy.euType"
                                                               placeholder="请选择"
                                                               @change="customerType" v-if="isagent">
                                                        <el-option v-for="(item) in options2"
                                                                   :key="item.code"
                                                                   :label="item.name"
                                                                   :value="item.code"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName"
                                                              :clearable="true">
                                                    <el-input v-model="zy.euName" :v="zy.euName" :disabled="true" v-if="!isagent"></el-input>
                                                    <el-select v-model="zy.euName" :v="zy.euName" filterable remote
                                                               placeholder="请输入"
                                                               :remote-method="showFormList" @change="showForm"  v-if="isagent">
                                                        <el-option v-for="(item) in EuName"
                                                                   :key="item.id"
                                                                   :label="item.userName"
                                                                   :value="item.userName">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                                                    <brselect category="YLRegion" v-model="zy.areaCode" :v="zy.areaCode"></brselect>
                                                </el-form-item>
                                                <el-form-item label="部门/科室" class="h-elformWrap-2" prop="department">
                                                    <el-input v-model="zy.department"
                                                              :v="zy.department" placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                                    <el-input v-model="zy.contactuserName"
                                                              :v="zy.contactuserName"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                                    <el-input v-model="zy.telephone"
                                                              :v="zy.telephone" placeholder="请输入"></el-input>
                                                </el-form-item>
<!--                                                <el-form-item label="需求类型" class="h-elformWrap-2">-->
<!--                                                    <el-input value="资源需求" readonly></el-input>-->
<!--                                                </el-form-item>-->
                                                <el-form-item label="链群" class="h-elformWrap-2" prop="lianqun">
                                                    <brselect category="gh_lianqun" v-model="zy.lianqun" :v="zy.lianqun"></brselect>
                                                </el-form-item>
                                                <el-form-item label="答复截止时间" class="h-elformWrap-2" prop="endDate">
                                                    <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                                                                    placeholder="选择时间"
                                                                    style="width: 3.1rem"
                                                                    :clearable="false" :picker-options="pickerOptions"
                                                                    v-model="zy.endDate">
                                                    </el-date-picker>
                                                </el-form-item>
                                                <el-form-item label="痛点" class="h-elformWrap-1" prop="pain">
                                                    <el-input v-model="zy.pain"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                                <el-form-item label="需求说明" class="h-elformWrap-1" prop="content">
                                                    <el-input v-model="zy.content"
                                                              placeholder="请输入"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                    <div class="h-table h-mrt30 ljjtablepaddingsxuqiu" style="margin: 20px 20px 0 10px;">
                                        <div class="h-pieceTitle2 message">
                                            <h1 class="h1">资源需求部门</h1>
                                        </div>
                                        <el-table
                                                ref="multipleTable"
                                                :data="deptList"
                                                :border="true"
                                                stripe
                                                style="width: 100%">
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="jobGroup"
                                                    label="场景"
                                                    width="300">
                                                <template scope="scope">
                                                    <el-select class="h-tableInput" v-model="scope.row.jobGroup" :v="scope.row.jobGroup"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="selectUser(scope.row)">
                                                        <el-option v-for="(item) in JobGroup"
                                                                   :key="item.id"
                                                                   :label="item.jobGroup"
                                                                   :value="item.jobGroup"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="jobGroupPoint"
                                                    label="链群节点"
                                                    width="250">
                                                <template scope="scope">
                                                    <el-select class="h-tableInput" v-model="scope.row.jobGroupPoint" :v="scope.row.jobGroupPoint"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="selectUser(scope.row)">
                                                        <el-option value="创单" label="创单"></el-option>
                                                        <el-option value="体验" label="体验"></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="pointUser"
                                                    label="部门及回复人"
                                                    min-width="400">
                                                <template scope="scope">
                                                    <el-select class="h-tableInput" v-model="scope.row.pointUser" :v="scope.row.pointUser"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="getNameCode(scope.row)">
                                                        <el-option v-for="(item) in PointUser"
                                                                   :key="item.id"
                                                                   :label="item.pointUser"
                                                                   :value="item.pointUser"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" fixed="right" width="100">
                                                <template slot-scope="scope">
                                                   <el-button
                                                            type="text"
                                                            class="h-tableLink h-btn"
                                                            @click="deleteThis(scope.$index)">
                                                        删除
                                                    </el-button>
													<!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.$index)"></span>
													</div> -->
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <div class="h-tableAdd">
                                            <a @click="add">新增一行</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-txtCenter h-mrt60">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backL">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="savezy()">确认提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import customer from "../../../api/loud/fanli/customer";

    export default {
        data() {
            return {
                isagent:true,
                ag:{},
                j:{
                    jobGroup: null,
                    jobGroupPoint: null,
                },
                //部门及回复人
                PointUser: [],
                //链群
                JobGroup: [],
                //资源需求回复部门列表
                deptList: [],
                f: {
                    userName: null,
                },
                checkflagchilds: false,
                LevelName: [],
                value: false,
                //用户列表
                optionsCustomer: [],
                //经销商列表
                optionsAgent: [],
                //用户类型 用户2 客户1
                options2: [],
                EuName: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                zy: {
                    userName: null,
                    euName: null,
                    euCode: null,
                    demandType: null,
                    demandType: 3,
                    contactuserName: null,
                    department: null,
                    telephone: null,
                    endDate: null,
                    deptList: [],
                    areaCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                },
                customer: {
                    areaCode: null,
                },
                rules: {
                    euType: [{required: true, message: '请选择客户类型', trigger: 'blur'}],
                    euName: [{required: true, message: '请选择客户全称', trigger: 'blur'}],
                    areaCode: [{required: true, message: '请选择区域', trigger: 'change'}],
                    department: [{required: true, message: '请填写部门/科室', trigger: 'change'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'change'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'change'}],
                    pain: [{required: true, message: '请填写痛点', trigger: 'blur'}],
                    content: [{required: true, message: '请填写需求说明', trigger: 'blur'}],
                    endDate: [{required: true, message: '请选择答复截止时间', trigger: 'blur'}],
                    lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
                }
            }
        },
        created() {
            this.options2 = this.$store.getters.dicts["userCareType"];
            this.query();
            this.selectJobGroup();
            this.isAgent();
        },
        methods: {
            //带出用户编码
            getNameCode(value) {
                    this.PointUser.forEach(elements => {
                        if (value.pointUser == elements.pointUser) {
                            value.jobPoint = elements.jobPoint;
                            value.jobUsername = elements.jobUsername;
                            value.jobUsercode = elements.jobUsercode;
                        }
                    })
            },
            //用户名列表
            selectUser(value) {
                value.pointUser = null;
                this.j.jobGroup = value.jobGroup;
                this.j.jobGroupPoint = value.jobGroupPoint;
                ss.UserDemand.selectUser(this.j).then(rd => {
                    this.PointUser = rd;
                });
            },
            //部门列表
            selectJobGroup() {
                ss.UserDemand.selectJobGroup().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //删除该行项目产品信息
            deleteThis(index) {
                this.deptList.splice(index, 1);
            },
            add() {
                var list = {
                    jobGroup: null,
                    jobGroupPoint: null,
                    pointUser: null,
                    jobPoint:null,
                    jobUsername:null,
                    jobUsercode:null
                }
                this.deptList.push(list);
            },
            customerType() {
                this.zy.euName = null;
                this.customer.areaCode = null;
                this.customer.channelCode = null;
                this.zy.contactuserName = null;
                this.zy.department = null;
                this.zy.telephone = null;
                this.EuName = null;
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.f.userName = value;
                if (this.zy.euType == 1) {
                    ss.UserCare.agentOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.zy.euType == 2) {
                    ss.UserCare.customerOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            showForm() {
                for (var i = 0; i < this.EuName.length; i++) {
                    if (this.zy.euName == this.EuName[i].userName) {
                        this.zy.euCode = this.EuName[i].userCode;
                        this.zy.areaCode = this.EuName[i].areaCode;
                        this.zy.contactuserName = this.EuName[i].contactuserName;
                        this.zy.department = this.EuName[i].department;
                        this.zy.telephone = this.EuName[i].telephone;
                    }
                }
            },
            query() {
                this.zy.id = this.$route.query.id;
                if (this.zy.id != null) {
                    ss.UserDemand.demandDetail3(this.zy.id).then(rd => {
                        this.zy = rd;
                        this.zy.euType = this.$getDictName("userCareType", rd.euType);
                        this.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                    });
                }
            },
            savezy() {
                var subflag = false;
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善需求信息后再提交！");
                        return false;
                    }
                });
                if (subflag) {
                    if (this.deptList.length != 0) {
                        var depflag = true;
                        this.deptList.forEach(e => {
                            if (e.jobGroup == null || e.jobGroupPoint == null || e.pointUser == null) {
                                depflag = false;
                                this.$msg.msge("请完善资源需求部门信息再提交！");
                                return false;
                            }
                        });
                        if (depflag) {
                            this.zy.demandType = 3;
                            this.zy.deptList = this.deptList;
                            this.$msg.confirm("确认提交该资源需求?", () => {
                                ss.UserDemand.savezy(this.zy).then(rd => {
                                    this.$msg.msgs("操作成功");
                                    this.$router.go(-1);
                                });
                            });
                        }
                    } else {
                        this.$msg.msge("请完善资源需求部门信息再提交！");
                        return false;
                    }
                }
            },
            backL() {
                this.$router.go(-1);
            },
            //经销商自身数据
            isAgent(){
                if(this._user.usertype == 1){
                    this.isagent = false;
                    this.zy.euType = 1;
                    this.zy.euName = this._user.username;
                    this.zy.euCode = this._user.usercode;
                    this.ag.usercode = this._user.usercode;
                    ss.UserDemand.getByCode(this.ag).then(rd=>{
                        this.zy.areaCode = rd.region;
                        this.customer.areaCode = this.$getDictName("YLRegion", rd.areaCode);
                 });

                }
            },
        }
    }
</script>
<style scoped>
    .checkidBox {
        position: relative;
        overflow: hidden;
        border: 1px solid #ccc;
        padding: 5px 10px;
        margin-left: 20px;
        cursor: pointer;
        border-radius: 5px;
        height: 39px;
        line-height: 39px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .checksBox:first-child {
        margin-left: 0;
    }

    .checkBoxs {
        height: 30px;
        line-height: 30px;
        padding: 5px;
        font-size: 12px;
    }

    .checkBoxs:first-child {
        margin-left: 0;
    }

    .checkidBox.active {
        border-color: #0e75e9;
        background: #0e75e9;
        color: #fff;
    }

    .inputlabel {
        position: absolute;
        left: -20px;
        top: 0;
        z-index: 3;
        padding-left: 7px !important;
        font-size: 14px !important;
        margin: 4px 0 0;
    }
</style>

<style>
    /* .h-formbLine1 .el-form-item__label{
	width: 21%!important;
}
.h-formbLine1 .el-form-item__content{
	width: 79%!important;
}
.h-formbLine1 .h-elformWrap-1 .el-form-item__label{
	width: 9.7%!important;
}
.h-formbLine1 .h-elformWrap-1 .el-form-item__content{
	width: 90.3%!important;
} */
    .weekplandetail34 .h-formbLine .el-form-item__label {
        width: 34%;
        text-align: right;
    }

    .weekplandetail34 .h-formbLine .el-form-item__content {
        width: 66%;
    }

    .weekplandetail34 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail34 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail34 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 10.7%;
    }

    .weekplandetail34 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 89.3%;
    }

    .h-formLine .el-checkbox__input {
        display: none;
    }

    .h-formLine .el-checkbox.is-bordered.is-checked {
        background: #2c83fd;
    }

    .h-formLine .el-checkbox-button.is-checked .el-checkbox-button__inner::after {
        content: "";
        background: url(../../../assets/images/checkBox.png);
        width: 10px;
        height: 10px;
    }

    .h-formLine .el-checkbox-button__inner {
        border: none;
        pazying: 9px 15px;
    }

    .h-formLine .el-checkbox-button:first-child .el-checkbox-button__inner {
        border-radius: 0;
    }

    .h-formLine .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #2c83fd;
    }

    .h-formLine .el-checkbox-button:last-child .el-checkbox-button__inner {
        border-radius: 0;
    }
	.ljjtablepaddingsxuqiu .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddingsxuqiu .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
